import React, { useState, FormEvent } from 'react';
import { Button } from '../common';
import './ChatInput.css';

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
  onOpenSymptomChecker?: () => void;
  onOpenWorkoutBuilder?: () => void;
  onOpenNutritionPlanner?: () => void;
}

export const ChatInput: React.FC<ChatInputProps> = ({
  onSend,
  disabled = false,
  isLoading = false,
  onOpenSymptomChecker,
  onOpenWorkoutBuilder,
  onOpenNutritionPlanner,
}) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (message.trim() && !disabled && !isLoading) {
      onSend(message.trim());
      setMessage('');
    }
  };

  return (
    <form className="chat-input-form" onSubmit={handleSubmit}>
      <div className="chat-input-wrapper">
        <div className="chat-input-row">
          {onOpenSymptomChecker && (
            <button
              type="button"
              className="symptom-checker-btn"
              onClick={onOpenSymptomChecker}
              title="Check Symptoms"
              disabled={disabled}
            >
              <span className="symptom-icon">🩺</span>
              <span className="symptom-text">Symptoms</span>
            </button>
          )}
          {onOpenWorkoutBuilder && (
            <button
              type="button"
              className="workout-builder-btn"
              onClick={onOpenWorkoutBuilder}
              title="Build Workout Plan"
              disabled={disabled}
            >
              <span className="workout-icon">💪</span>
              <span className="workout-text">Workout</span>
            </button>
          )}
          {onOpenNutritionPlanner && (
            <button
              type="button"
              className="nutrition-planner-btn"
              onClick={onOpenNutritionPlanner}
              title="Nutrition Planner"
              disabled={disabled}
            >
              <span className="nutrition-icon">🍽️</span>
              <span className="nutrition-text">Nutrition</span>
            </button>
          )}
          <textarea
            className="chat-input"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Ask a health question..."
            disabled={disabled || isLoading}
            rows={1}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSubmit(e);
              }
            }}
          />
        </div>
        <Button
          type="submit"
          variant="primary"
          disabled={!message.trim() || disabled}
          isLoading={isLoading}
          className="chat-send-btn"
        >
          <span className="send-text">Send</span>
          <span className="send-icon">➤</span>
        </Button>
      </div>
      <p className="chat-input-hint">
        Press Enter to send, Shift+Enter for new line
      </p>
    </form>
  );
};
